import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../user.service';
import { UserserviceService } from '../userservice.service';
@Component({
  selector: 'app-first-password',
  templateUrl: './first-password.component.html'
})
export class FirstPasswordComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private auth: UserserviceService,
    public router:Router,
  ) { }

  //@ts-ignore
  passwordForm: FormGroup;
  submitted: boolean = false;

  
ngOnInit(): void {
    this.passwordForm=this.formBuilder.group({
      email:['',Validators.required],
      password1:['',Validators.required],
      password:['',Validators.required],
      confirmPassword:['',Validators.required]
    })
}
butn:boolean=false;
  passwordVisible:boolean=false;
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  passwordVisible1:boolean=false;
  togglePasswordVisibility1() {
    this.passwordVisible1 = !this.passwordVisible1;
  }

  
  passwordVisible2:boolean=false;
  togglePasswordVisibility2() {
    this.passwordVisible2 = !this.passwordVisible2;
  }

  confirm(){
    console.log(this.passwordForm.value.password,this.passwordForm.value.confirmPassword)
    if(this.passwordForm.value.password==this.passwordForm.value.confirmPassword){
     this.butn=false;
    }
    else{
      this.butn=true;
    }
  }

  updatePassword(){
    this.butn=true;
  this.auth.updatePassword(this.passwordForm.value)
  }

}
